import Combox, { ComboxItemData, ComboxProps } from "~/components/shared/Combox";
import ComboxItem from "~/components/shared/Combox/ComboxItem";
import Emojify from "~/components/shared/Emojify";

interface SelectItemData extends ComboxItemData {
  description: string;
}

interface ComboxSelectProps extends ComboxProps {
  items: SelectItemData[];
  subtle?: boolean;
}
const ComboxSelect = (props: ComboxSelectProps) => (
  <Combox
    triggerProps={{
      placeholder: "Nothing selected",
      subtle: !!props.subtle,
      className:
        "w-full justify-between !min-h-0 text-sm px-[5px] py-0.5 flex bg-transparent hover:bg-white data-[state=open]:bg-white border rounded-sm border-transparent hover:border-gray-300 data-[state=open]:border-gray-600 data-[state=open]:hover:border-gray-600",
    }}
    filterProps={{ placeholder: "Search" }}
    {...props}
  >
    {props.items?.map((item) => (
      <ComboxItem key={item.value} value={item.value} disabled={item.disabled}>
        <div className="grid cursor-pointer grid-cols-1 items-center gap-x-2 gap-y-0 rounded-sm p-1">
          <div className="text-sm font-medium">
            <Emojify text={item.label} />
          </div>
          <div className="text-charcoal-300 hover:text-charcoal-300 text-xs font-normal">
            <Emojify text={item.description} />
          </div>
        </div>
      </ComboxItem>
    ))}
  </Combox>
);

export default ComboxSelect;
